import React from "react"
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap"
import { useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { deleteCacheByKey } from "../../view/shared/utilities/cache"
import { Trans } from "@lingui/react"
import { triggerAction } from "../../store/constants"
import { setCurrentPage } from "../../store/reducers/navigation"

const DropMenu = (props) => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false)
  const dispatch = useDispatch()
  const toggle = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setDropdownOpen((prevState) => !prevState)
  }

  const remove = async () => {
    if (confirm(`Are you sure you want to remove ${props.member.full_name}`)) {
      await deleteCacheByKey("offlineRequests", "tempId", props.cacheKey)
      dispatch(triggerAction("REMOVE_MEMBER", { key: "cacheId", value: props.cacheKey }))
      dispatch(triggerAction("TOGGLE_FAILED_TO_UPLOAD", false)) // remove the error banner
    }
  }

  const edit = () => {
    dispatch(triggerAction('UPDATE_MEMBER_TO_EDIT', props.member))
    dispatch(setCurrentPage('group-addMember'))
  }

  return (
    <>
      <Dropdown direction="end" isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle
          tag="span"
          data-toggle="dropdown"
          aria-expanded={dropdownOpen}
          style={{
            color: "#000",
            fontSize: "15px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          &#8942;
        </DropdownToggle>
        <DropdownMenu
          style={{
            minWidth: "fit-content",
            padding: "8px",
            fontSize: 13,
            cursor: "pointer",
          }}
        >
          {props.member.member_role.toLocaleLowerCase() !== "secretary" && (
            <button
              style={{
                padding: "8px",
                fontWeight: 600,
                borderWidth: 0,
                background: "red",
                borderRadius: "4.8px",
                marginTop: 10,
                color: "#fff",
                width: "80px",
                display: props.showDelete ? "inline" : "none",
              }}
              onClick={remove}
            >
              <Trans id="remove" />
            </button>
          )}
          <button
            style={{
              padding: "8px",
              fontWeight: 600,
              borderWidth: 0,
              background: "#E36F1E",
              borderRadius: "4.8px",
              marginTop: 10,
              color: "#fff",
              width: "80px",
              display: "inline",
            }}
            onClick={edit}
          >
            <Trans id="edit" />
          </button>
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

DropMenu.propTypes = {
  namespace: PropTypes.string,
  cacheKey: PropTypes.string,
  retryFunc: PropTypes.func,
  member: PropTypes.object,
  showDelete: PropTypes.bool,
}

export default DropMenu
